if (!customElements.get('sd-home-banner')) {
  customElements.define('sd-home-banner', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const listen = (target, name, handler) => target.addEventListener(name, handler, {signal:this.abort.signal});
      this.track = this.querySelector('.sd-banner__track');
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-go]')];
      this.index = 0;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches || this.dataset.autoplay !== 'true';
      this.slider = this.dataset.slider === 'true' && this.slides.length > 1;
      if (!this.slider) return;
      this.pauseButton = this.querySelector('[data-pause]');
      listen(this, 'click', event => {
        const direction = event.target.closest('[data-direction]');
        const dot = event.target.closest('[data-go]');
        if (direction || dot) {
          this.paused = true;
          this.go(dot ? Number(dot.dataset.go) : this.index + Number(direction.dataset.direction));
          this.schedule();
        }
        if (event.target.closest('[data-pause]')) { this.paused = !this.paused; this.schedule(); }
      });
      listen(this.track,'scroll',()=> {
        const index = Math.round(Math.abs(this.track.scrollLeft) / this.track.clientWidth);
        if (index !== this.index) { this.index = index; this.sync(); }
      });
      listen(this.track,'keydown',event=> {
        if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault(); this.paused = true;
        this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1)); this.schedule();
      });
      listen(this.track,'pointerdown',()=>{ this.paused = true; this.schedule(); });
      listen(this,'mouseenter',()=>{ this.hovering = true; this.schedule(); });
      listen(this,'mouseleave',()=>{ this.hovering = false; this.schedule(); });
      listen(this,'focusin',()=>this.schedule());
      listen(this,'focusout',()=>queueMicrotask(()=>this.schedule()));
      listen(document,'visibilitychange',()=>this.schedule());
      listen(this.reduced,'change',()=>{ if(this.reduced.matches) this.paused = true; this.schedule(); });
      listen(document,'shopify:block:select',event=>{
        const index = this.slides.findIndex(slide=>slide.dataset.blockId === event.detail.blockId);
        if(index>=0) { this.paused = true; this.go(index, false); this.schedule(); }
      });
      this.resize = new ResizeObserver(()=>this.go(this.index,false));
      this.resize.observe(this.track);
      this.sync(); this.schedule();
    }
    go(index, smooth = true) {
      this.index = (index + this.slides.length) % this.slides.length;
      const sign = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
      this.track.scrollTo({left:sign*this.index*this.track.clientWidth,behavior:smooth&&!this.reduced.matches?'smooth':'instant'});
      this.sync();
    }
    sync() {
      this.dots.forEach((dot,index)=>{ if(index===this.index) dot.setAttribute('aria-current','true'); else dot.removeAttribute('aria-current'); });
      this.slides.forEach((slide,index)=>{ slide.inert=index!==this.index; });
      const announcement = this.querySelector('[data-announcement]');
      if (announcement && this.paused) announcement.textContent=this.slides[this.index]?.getAttribute('aria-label') || '';
    }
    schedule() {
      clearInterval(this.timer);
      if(this.pauseButton) {
        const label=this.paused?this.pauseButton.dataset.playLabel:this.pauseButton.dataset.pauseLabel;
        this.pauseButton.setAttribute('aria-label',label); this.pauseButton.title=label;
        this.pauseButton.querySelector('[data-play-symbol]').hidden=!this.paused;
        this.pauseButton.querySelector('[data-pause-symbol]').hidden=this.paused;
      }
      if(!this.paused&&!this.hovering&&!this.contains(document.activeElement)&&!document.hidden) this.timer=setInterval(()=>this.go(this.index+1),Number(this.dataset.interval)||6000);
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); clearInterval(this.timer); }
  });
}
